import type { ProductPromotion } from '@libs/common-next';
import type { EligiblePromotion } from '@libs/common-types';
import PromoItem from './PromoItem';

type PromoListProps = {
    readonly promotions: ProductPromotion[] | EligiblePromotion[];
    readonly isCTEnabled: boolean;
};

export default function PromoList({ promotions, isCTEnabled }: PromoListProps) {
    const promoKey = (
        promotion: ProductPromotion | EligiblePromotion
    ): string =>
        isCTEnabled
            ? ((promotion as EligiblePromotion).promoKey as string)
            : (promotion as ProductPromotion).promotion_id;

    return (
        <div className="product-promotions-list">
            {promotions.map(promotion => (
                <PromoItem
                    promotion={promotion}
                    isCTEnabled={isCTEnabled}
                    key={promoKey(promotion)}
                />
            ))}
        </div>
    );
}
